import React, { useState } from "react";
import {
  Paper,
  Typography,
  Grid,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  Icon,
  TableFooter,
  TablePagination,
} from "@material-ui/core";
import { LOCALE } from "../../../properties/Locale";
import { useDispatch } from "react-redux";
import { changePageTitle } from "../../../common/actions/CommonActions";
import { VacancyRepository } from "../../vacancy/VacancyRepository";
import { VacancyAppRepository } from "../../vacancyApplication/VacancyAppRepository";
import Card from "../../../common/components/Card/Card";
import CardHeader from "../../../common/components/Card/CardHeader";
import CardBody from "../../../common/components/Card/CardBody";
import { useStyles } from "@material-ui/pickers/views/Calendar/SlideTransition";
import moment from "moment";
import { Redirect } from "react-router-dom";

export default function CommissionGradingComponent() {
  const dispatch = useDispatch();
  const classes = useStyles();

  const [vacancyApps, setVacancyApps] = React.useState();
  const [totalAppsRemaining, setTotalAppsRemaining] = React.useState(0);
  const [redirect, setRedirect] = React.useState();
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);

  React.useEffect(() => {
    dispatch(changePageTitle(LOCALE.commission_grading));
  }, [dispatch]);

  React.useEffect(() => {
    VacancyAppRepository.getAll({
      page: page,
      size: size,
      orderBy: "dateCreated",
      orderDirection: "DESC",
      filterBy: "status",
      filterValue: "COMMISION_EVAL",
    }).then((res) => {
      setTotalAppsRemaining(res.data.totalElements);
      setVacancyApps(res.data);
      console.log(res.data);
    });
  }, [page, size]);

  const openVacancy = (vacId, appId) => {
    setRedirect("/app/vacancy-evaluation/" + vacId + "/" + appId);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setSize(parseInt(event.target.value, 10));
  };

  return (
    <div>
      {redirect && <Redirect to={redirect} />}
      <Card>
        <CardHeader color="theme">
          <Typography>{LOCALE.apps_for_commission_evaluation}</Typography>
          <Typography style={{ float: "right" }}>
            {LOCALE.total_left}: {totalAppsRemaining}
          </Typography>
        </CardHeader>
        <CardBody>
          <Table aria-label="users table" className={classes.table}>
            <TableHead>
              <TableRow className={classes.tableHeadRow}>
                <TableCell
                  style={{ fontWeight: "bold" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.school}
                </TableCell>
                <TableCell
                  style={{ fontWeight: "bold" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.teaching_languages}
                </TableCell>
                <TableCell
                  style={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.created_at}
                </TableCell>
                <TableCell
                  style={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.submissionDate}
                </TableCell>
                <TableCell
                  style={{ fontWeight: "bold", textAlign: "center" }}
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.status}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                  style={{
                    width: "100px",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  {LOCALE.actions}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {vacancyApps?.content && vacancyApps.content.length === 0 && (
                <TableRow>
                  <TableCell colSpan={10}>
                    <Icon style={{ verticalAlign: "bottom", color: "orange" }}>
                      warning
                    </Icon>
                    {LOCALE.no_apps_for_evaluating}
                  </TableCell>
                </TableRow>
              )}
              {vacancyApps?.content?.map((vacancyApp, index) => (
                <TableRow
                  style={index % 2 === 1 ? { background: "#f0f0f0" } : {}}
                >
                  <TableCell>{vacancyApp.basicInfo.school.name}</TableCell>
                  <TableCell>
                    {LOCALE.getString(vacancyApp.basicInfo.teachingLanguage)}
                  </TableCell>
                  <TableCell style={{ textAlign: "center" }}>
                    {vacancyApp.dateCreated &&
                      moment(vacancyApp.dateCreated).format(
                        "YYYY-MM-DD HH:mm:ss"
                      )}
                  </TableCell>
                  <TableCell style={{ textAlign: "center" }}>
                    {vacancyApp.submissionDate &&
                      moment(vacancyApp.submissionDate).format(
                        "YYYY-MM-DD HH:mm:ss"
                      )}
                  </TableCell>
                  <TableCell style={{ textAlign: "center" }}>
                    {vacancyApp.status && vacancyApp.status === "DRAFT" && (
                      <Chip
                        label={LOCALE.getString("DRAFT")}
                        style={{
                          color: "white",
                          backgroundColor: "orange",
                        }}
                      />
                    )}
                    {vacancyApp.status &&
                      vacancyApp.status === "COMMISION_EVAL" && (
                        <Chip
                          label={LOCALE.getString("COMMISION_EVAL")}
                          style={{
                            color: "white",
                            backgroundColor: "green",
                          }}
                        />
                      )}
                  </TableCell>
                  <TableCell>
                    <Button
                      color="primary"
                      variant="contained"
                      size="small"
                      onClick={() =>
                        openVacancy(vacancyApp.vacancy.id, vacancyApp.id)
                      }
                    >
                      <Icon size={10}>edit</Icon> &nbsp;
                      {LOCALE.open}
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  colSpan={6}
                  count={vacancyApps?.totalElements}
                  rowsPerPage={size}
                  page={vacancyApps?.number}
                  labelRowsPerPage={LOCALE.rows_per_page}
                  SelectProps={{
                    inputProps: { "aria-label": LOCALE.rows_per_page },
                    native: true,
                  }}
                  onChangePage={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </CardBody>
      </Card>
    </div>
  );
}
